module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticClass: "c-featured-value"
  }, [_c('h6', {
    staticClass: "text-muted text-uppercase"
  }, [_c('small', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t(_vm.title)))])]), _vm._v(" "), _c('p', {
    staticClass: "c-featured-value__text",
    class: [_vm.colored ? 'u-color-' + _vm.element.elementGroup : '']
  }, [_vm._v(_vm._s(_vm.value))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d965f46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElementProfile/FeaturedValue.vue
// module id = 647
// module chunks = 1